(function(){
  'use strict';
  var RE_NOTE=/laid flat|double the chest|allow about/i;
  function findSource(){
    // PQ theme splits the description into accordions: the chart sits in details#pq-size-guide .pq-size-table.
    // Fall back to the raw description markup (div.size-guide) for other templates.
    var acc=document.getElementById('pq-size-guide');
    if(acc&&acc.querySelector('table'))return {box:acc,table:acc.querySelector('table'),notesFrom:acc.querySelector('.pq-acc__body')||acc};
    var d=document.querySelector('.product__description .size-guide, .size-guide');
    if(d&&d.querySelector('table'))return {box:d,table:d.querySelector('table'),notesFrom:d};
    return null;
  }
  function el(tag,attrs,text){var e=document.createElement(tag);if(attrs)for(var k in attrs)e.setAttribute(k,attrs[k]);if(text!=null)e.textContent=text;return e;}
  var dlg=null,closeBtn=null,lastTrigger=null,scrollEl=null,wrapEl=null,thumbEl=null,nudged=false;
  function syncScroll(){
    if(!scrollEl)return;var s=scrollEl,max=s.scrollWidth-s.clientWidth,x=s.scrollLeft;
    var on=max>1;wrapEl.classList.toggle('is-scrollable',on);
    wrapEl.classList.toggle('is-start',x<=1);wrapEl.classList.toggle('is-end',x>=max-1);
    var c1=s.querySelector('th');if(c1)wrapEl.style.setProperty('--pq-sg-col1',c1.getBoundingClientRect().width+'px');
    // native bar height 0 => overlay scroll bars (iOS Safari, macOS): show the JS progress thumb
    wrapEl.classList.toggle('pq-sg--jsbar',on&&(s.offsetHeight-s.clientHeight-(parseFloat(getComputedStyle(s).borderTopWidth)||0)-(parseFloat(getComputedStyle(s).borderBottomWidth)||0))<2);
    if(on){var w=s.clientWidth/s.scrollWidth*100;thumbEl.style.width=w+'%';thumbEl.style.transform='translateX('+(x/max*(100/w*100-100))+'%)';}
  }
  function nudge(){
    if(nudged||!scrollEl||!matchMedia('(max-width:749px)').matches||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(scrollEl.scrollWidth-scrollEl.clientWidth<=1)return;nudged=true;
    setTimeout(function(){scrollEl.scrollTo({left:24,behavior:'smooth'});setTimeout(function(){scrollEl.scrollTo({left:0,behavior:'smooth'});},450);},350);
  }

  function build(src){
    var rows=[].slice.call(src.table.rows);if(rows.length<2)return false;
    var head=[].slice.call(rows[0].cells).map(function(c){return c.textContent.trim();});
    var centerBack=false;
    function shortLabel(t){
      if(/center\s*back/i.test(t))centerBack=true;
      if(/sleeve/i.test(t))return 'Sleeve';
      if(/chest|width/i.test(t))return 'Chest';
      if(/length/i.test(t))return 'Length';
      return t;
    }
    var uid='pqSg'+Math.random().toString(36).slice(2,7);
    dlg=el('dialog',{'class':'pq-sg','aria-labelledby':uid+'-t',id:'pq-sg-dialog'});
    var hd=el('div',{'class':'pq-sg__head'});
    hd.appendChild(el('h2',{'class':'pq-sg__title',id:uid+'-t'},'Size guide'));
    closeBtn=el('button',{type:'button','class':'pq-sg__close','aria-label':'Close size guide'});
    closeBtn.innerHTML='<svg width="16" height="16" viewBox="0 0 14 14" aria-hidden="true"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>';
    hd.appendChild(closeBtn);dlg.appendChild(hd);
    var bd=el('div',{'class':'pq-sg__body'});
    var sc=el('div',{'class':'pq-sg__scroll',tabindex:'0',role:'region','aria-label':'Size chart, scrolls sideways'});
    var t=el('table',{'class':'pq-sg__table'}),th=el('thead'),tr=el('tr');
    head.forEach(function(h,i){tr.appendChild(el('th',{scope:'col'},i===0?'Inches':h));});
    th.appendChild(tr);t.appendChild(th);
    var tb=el('tbody');
    rows.slice(1).forEach(function(r){var row=el('tr');[].slice.call(r.cells).forEach(function(c,i){var v=c.textContent.trim();row.appendChild(i===0?el('th',{scope:'row'},shortLabel(v)):el('td',null,v));});tb.appendChild(row);});
    t.appendChild(tb);sc.appendChild(t);
    var tw=el('div',{'class':'pq-sg__tablewrap'});tw.appendChild(sc);
    tw.appendChild(el('div',{'class':'pq-sg__fade pq-sg__fade--l','aria-hidden':'true'}));
    tw.appendChild(el('div',{'class':'pq-sg__fade pq-sg__fade--r','aria-hidden':'true'}));
    var bar=el('div',{'class':'pq-sg__bar','aria-hidden':'true'}),thumb=el('div',{'class':'pq-sg__thumb'});bar.appendChild(thumb);tw.appendChild(bar);
    bd.appendChild(tw);scrollEl=sc;wrapEl=tw;thumbEl=thumb;
    sc.addEventListener('scroll',syncScroll,{passive:true});
    window.addEventListener('resize',syncScroll);
    var key=el('div',{'class':'pq-sg__key'});
    key.appendChild(el('p',null,'Inches, garment laid flat. Chest = armpit to armpit, double it for the full chest. Allow about \u00b11 inch.'));
    if(centerBack)key.appendChild(el('p',null,'Sleeve measured from center back.'));
    bd.appendChild(key);
    var notes=[].slice.call(src.notesFrom.querySelectorAll('p')).filter(function(p){return p.textContent.trim()&&!RE_NOTE.test(p.textContent);});
    if(notes.length){var nd=el('div',{'class':'pq-sg__notes'});notes.forEach(function(p){nd.appendChild(el('p',null,p.textContent.trim()));});bd.appendChild(nd);}
    dlg.appendChild(bd);document.body.appendChild(dlg);

    closeBtn.addEventListener('click',shut);
    dlg.addEventListener('close',function(){document.documentElement.classList.remove('pq-sg-lock');if(lastTrigger&&document.contains(lastTrigger))lastTrigger.focus();});
    dlg.addEventListener('cancel',function(e){e.preventDefault();shut();});
    dlg.addEventListener('click',function(e){if(e.target!==dlg)return;var r=dlg.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)shut();});
    dlg.addEventListener('keydown',function(e){
      if(e.key==='Escape'){e.preventDefault();shut();return;}
      if(e.key!=='Tab')return;var f=focusables();if(!f.length)return;var a=f[0],z=f[f.length-1];
      if(e.shiftKey&&(document.activeElement===a||!dlg.contains(document.activeElement))){e.preventDefault();z.focus();}
      else if(!e.shiftKey&&(document.activeElement===z||!dlg.contains(document.activeElement))){e.preventDefault();a.focus();}
    });
    return true;
  }
  function focusables(){return [].slice.call(dlg.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(n){return !n.disabled&&n.getClientRects().length;});}
  function atcOffset(){
    var h=0;[].slice.call(document.body.querySelectorAll('*')).forEach(function(n){
      if(n===dlg||(dlg&&dlg.contains(n)))return;var cs=getComputedStyle(n);
      if(cs.position==='fixed'&&cs.display!=='none'&&cs.visibility!=='hidden'&&+cs.opacity>0){var r=n.getBoundingClientRect();if(r.height>0&&r.height<200&&r.bottom>=innerHeight-2&&r.top<innerHeight&&r.width>innerWidth*0.5)h=Math.max(h,r.height);}
    });return Math.round(h);
  }
  function open(trigger){
    if(!dlg)return;lastTrigger=trigger;
    dlg.style.setProperty('--pq-sg-atc',atcOffset()+'px');
    document.documentElement.classList.add('pq-sg-lock');
    dlg.showModal();closeBtn.focus();syncScroll();nudge();
  }
  function shut(){if(dlg&&dlg.open)dlg.close();}

  function init(){
    if(dlg||typeof HTMLDialogElement==='undefined')return;
    var src=findSource();if(!src)return;
    if(!build(src))return;
    document.documentElement.classList.add('pq-sg-ready');
    // Where the table was: hide the inline chart, leave a pill in its place
    src.box.classList.add('pq-sg-src');
    // Accordion item stays hidden (data source only); the only trigger lives by the size picker.
    [].slice.call(document.querySelectorAll('.pq-sg-inline')).forEach(function(n){n.remove();});
    // Near the size picker: the theme already renders a.pq-sizeguide-link in the Size legend (re-rendered on variant change), so use delegation.
    document.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('[data-pq-sizeguide],[data-pq-sg-open],a[href="#pq-size-guide"]');
      if(!a||(dlg&&dlg.contains(a)))return;
      e.preventDefault();e.stopImmediatePropagation();open(a);
    },true);
    function ensurePicker(){
      if(document.querySelector('[data-pq-sizeguide],.pq-sg-trigger--picker'))return;
      var lg=[].slice.call(document.querySelectorAll('fieldset.product-form__input legend')).filter(function(l){return /size/i.test(l.textContent);})[0];
      if(!lg)return;
      var b=el('button',{type:'button','class':'pq-sg-trigger pq-sg-trigger--picker','aria-haspopup':'dialog','aria-controls':'pq-sg-dialog','data-pq-sg-open':''},'Size guide');
      lg.appendChild(b);lg.classList.add('pq-sg-legend');
    }
    function mark(){ensurePicker();[].slice.call(document.querySelectorAll('[data-pq-sizeguide],.pq-sg-trigger--picker')).forEach(function(a){var l=a.closest('legend');if(l)l.classList.add('pq-sg-legend');});[].slice.call(document.querySelectorAll('[data-pq-sizeguide]')).forEach(function(a){a.setAttribute('aria-haspopup','dialog');a.setAttribute('aria-controls','pq-sg-dialog');a.setAttribute('role','button');});}
    mark();new MutationObserver(mark).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
  }
  document.documentElement.classList.add('pq-sg-js');
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.PQSizeGuideInit=init;
})();
